// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SurveyRouteImport } from './routes/survey'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedOpenhumansRouteImport } from './routes/_authenticated/openhumans'
import { Route as AuthenticatedUploadRouteImport } from './routes/_authenticated/upload'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AuthenticatedOpenhumansCallbackRouteImport } from './routes/_authenticated/openhumans.callback'
import { Route as AuthenticatedReportJobIdRouteImport } from './routes/_authenticated/report.$jobId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const FeedbackRoute = FeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SurveyRoute = SurveyRouteImport.update({
            id: '/survey',path: '/survey',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOpenhumansRoute = AuthenticatedOpenhumansRouteImport.update({
            id: '/openhumans',path: '/openhumans',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedUploadRoute = AuthenticatedUploadRouteImport.update({
            id: '/upload',path: '/upload',getParentRoute: () => AuthenticatedRouteRoute
          })
const InviteTokenRoute = InviteTokenRouteImport.update({
            id: '/invite/$token',path: '/invite/$token',getParentRoute: () => rootRouteImport
          })
const AuthenticatedOpenhumansCallbackRoute = AuthenticatedOpenhumansCallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => AuthenticatedOpenhumansRoute
          })
const AuthenticatedReportJobIdRoute = AuthenticatedReportJobIdRouteImport.update({
            id: '/report/$jobId',path: '/report/$jobId',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedOpenhumansRouteChildren = {
  AuthenticatedOpenhumansCallbackRoute: AuthenticatedOpenhumansCallbackRoute
}

const AuthenticatedOpenhumansRouteWithChildren = AuthenticatedOpenhumansRoute._addFileChildren(AuthenticatedOpenhumansRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedOpenhumansRoute: AuthenticatedOpenhumansRouteWithChildren,AuthenticatedUploadRoute: AuthenticatedUploadRoute,AuthenticatedReportJobIdRoute: AuthenticatedReportJobIdRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,FeedbackRoute: FeedbackRoute,PrivacyRoute: PrivacyRoute,SurveyRoute: SurveyRoute,InviteTokenRoute: InviteTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)